import React from "react";
import { default as WInputBase } from "@mui/material/InputBase";

function InputBase(props) {
  return <WInputBase {...props} />;
}

export default InputBase;
